import { MouseEvent, ReactElement } from "react";
import { ItemMenu } from "../../components/baseMenu";
import { DynamicFormRefValues, DynamicRefRef } from "../../components/dynamicFormRef/types";
import { EvidencesTypeEnum } from "../../utils/enums/evidences";

type EvidenceData = Record<string, DynamicFormRefValues | undefined> | undefined
type DrawerEvidencesProps = {
  open: boolean;
  options?: {
    sameConfig: boolean;
  }
  disabledField?: boolean
  defaultValues: EvidenceData[] | undefined
  refsByKey: Record<string, DynamicRefRef | null>
  setRef: (element: DynamicRefRef | null, key: string) => void
  cancel: () => void;
  save: (data: EvidenceData[] | undefined, options?: { sameConfig: boolean }) => void
  headerElement?: ReactElement
  headerLabel?: string
  multiple?: boolean
  optionType?: EvidenceOptionType
  disabledButon?: boolean
}

export enum EvidenceOptionType {
  CREATOR = 'CREATOR',
  FOLIO_MANAGEMENT = 'FOLIO_MANAGEMENT',
  CREATION = 'CREATION',
  ACTIVITY_MANAGEMENT = 'ACTIVITY_MANAGEMENT'
}

type EvidenceDataHook = {
  anchorEl: HTMLElement | null,
  menu: ItemMenu[],
  openEvidenceDrawer: boolean,
  evidencesData: EvidenceData[],
  refsByKey: Record<string, DynamicRefRef | null>,
  evidencesCount: number,
  cleanAll: () => void,
  setRef: (element: DynamicRefRef | null, key: string) => void,
  closeMenu: () => void,
  saveEvidence: (data: EvidenceData[], getCount?: ((count: number) => void) | undefined, options?: {
    sameConfig: boolean;
  }) => void,
  cancelEvidence: () => void,
  clickOption: ClickOption
  fillData: FilData
  openMenu: ({ anchor, defaultValues }: {
    anchor: MouseEvent<HTMLButtonElement | HTMLDivElement>;
    values?: Record<EvidencesTypeEnum, boolean> | undefined;
    defaultValues?: EvidenceData[];
  }) => void
}
type FilData = ({ defaultValues }: {
  defaultValues?: EvidenceData[];
}) => void
type ClickOption = ({ item }: {
  item?: ItemMenu;
  defaultEvidencesData?: EvidenceData[]
}) => void
export type { EvidenceData, DrawerEvidencesProps, EvidenceDataHook, ClickOption }